// extracted by mini-css-extract-plugin
export default {"dashboard-team-projects":"style_dashboard-team-projects__O-6nv"};